import Marquee from "react-fast-marquee";

const logos = [
  { name: "NORTHWIND", font: "font-display font-bold tracking-tight" },
  { name: "ACME • CORP", font: "font-display font-light tracking-[0.25em]" },
  { name: "Globex", font: "font-serif italic font-semibold" },
  { name: "SOYLENT", font: "font-display font-extrabold tracking-widest" },
  { name: "Initech", font: "font-display font-medium tracking-tight" },
  { name: "UMBRELLA", font: "font-display font-black tracking-[0.2em]" },
  { name: "MassiveDynamic", font: "font-sans font-semibold" },
  { name: "Wayne / Ent.", font: "font-serif font-bold tracking-tight" },
];

export default function TrustedBy() {
  return (
    <section data-testid="trusted-by-section" className="py-16 border-y border-slate-200/70 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.28em] text-slate-500 mb-8">
          Trusted by growing businesses across India
        </p>
        <Marquee gradient gradientColor="#ffffff" gradientWidth={80} speed={38} pauseOnHover>
          {logos.concat(logos).map((l, i) => (
            <span key={i} className={`mx-10 text-xl md:text-2xl text-slate-400 hover:text-slate-600 transition-colors ${l.font}`}>
              {l.name}
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
